import { Flex, Text } from "@chakra-ui/react";
import { Text as JssText } from "@sitecore-jss/sitecore-jss-nextjs";

import { useRouter } from "next/router";
import NextLink from "commons/ui/NextLink";
import { type PartnerResult } from "components/PartnersFilter";
import SCImage from "commons/sc/SCImage";
import SCHeading from "commons/sc/SCHeading";

interface PartnerCardProps {
    item: PartnerResult;
    sizes: string;
}

const PartnerCard = ({ item, sizes }: PartnerCardProps) => {
    const { query } = useRouter();
    const firstTag =
        item?.tags?.jsonValue && item.tags.jsonValue.length > 0 && item.tags.jsonValue[0];

    return (
        <NextLink
            backgroundColor="brand.lighterGray"
            padding="sp16"
            paddingTop="sp8"
            key={item?.id}
            id={item?.id}
            _hover={{
                span: {
                    _before: {
                        right: "100%",
                    },
                },
            }}
            href={{
                query: {
                    ...query,
                    highlight: item.id,
                },
            }}
        >
            <Flex as="article" flexDirection="column" gap="sp16" justifyContent="space-between">
                <Flex
                    aspectRatio={"16 / 9"}
                    maxHeight="100%"
                    alignContent="center"
                    justifyContent="center"
                    objectFit="contain"
                    overflow="hidden"
                >
                    {item?.logo && (
                        <SCImage
                            imageField={item?.logo?.jsonValue}
                            width={Number(item?.logo?.jsonValue?.value?.width)}
                            height={Math.round(Number(item?.logo?.jsonValue?.value?.height))}
                            sizes={sizes}
                            sx={{
                                width: "auto",
                                height: "auto",
                                maxH: "100%",
                                maxW: "100%",
                            }}
                        />
                    )}
                </Flex>
                {item?.partnerName && (
                    <SCHeading
                        textField={item?.partnerName.jsonValue}
                        as="h3"
                        size="2xs"
                        textAlign="center"
                    />
                )}
                {firstTag && (
                    <Text as="p" size="bodySmall" textAlign="center" textTransform="capitalize">
                        <JssText
                            field={{
                                value: firstTag.displayName,
                            }}
                        />
                    </Text>
                )}
            </Flex>
        </NextLink>
    );
};

export default PartnerCard;
